var _ellipse, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsAmount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 67,
    viewBox: "0 0 56 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28,
    cy: 38.072,
    rx: 28,
    ry: 28.072,
    fill: "url(#paint0_linear_1319_4347)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.2254 24.1254L54.7791 23.1371L52.2842 22.1716L51.2686 19.333L50.2784 22.1005L47.5996 23.1371L50.3371 24.1965L51.2686 26.7997L52.2254 24.1254Z",
    fill: "#FFAE09"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1319_4347",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 6,
    width: 62,
    height: 98
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2228 97.682C45.1227 88.5648 59.9008 83.889 59.9008 83.889L36.7378 37.0286C34.8791 32.5668 35.1208 28.8702 35.3673 27.3249C35.5997 25.8721 35.7736 24.4108 36.3243 23.0491C36.994 21.3933 37.9677 19.2317 38.8554 18.2069C39.9583 16.9392 39.0051 14.9917 37.5387 15.332C36.0783 15.669 32.9519 19.0759 31.3674 24.2651C29.7889 29.4512 26.6928 21.6086 25.5181 18.7686C24.3434 15.9286 20.2921 7.33273 19.143 7.02842C17.4626 6.5806 16.6465 8.34302 17.8884 11.1482C19.14 13.9872 22.2628 22.645 20.7503 23.2259C19.2594 23.8035 13.4647 9.27616 13.4647 9.27616C13.4647 9.27616 12.7235 5.95624 10.9532 6.57762C7.76771 7.69855 15.058 22.6609 15.7852 24.0666C16.2911 25.0445 14.6756 25.7407 14.1868 24.661C13.6822 23.5507 8.73834 10.0243 5.48186 11.1277C2.98519 11.9776 11.3608 23.4964 10.8507 26.9135C10.3374 30.3246 5.37857 17.5031 3.02121 18.4126C2.14254 18.7509 1.53218 19.1286 5.4313 26.0523C7.52597 29.7722 12.1347 34.5779 15.6411 42.0456L16.5511 43.9844C21.8948 58.6133 37.3853 116.895 63.579 100.912L58.6843 98.8512C58.6843 98.8512 42.2217 97.6856 42.2228 97.682Z",
    fill: "#FFAE09"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1319_4347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.9988 38.0727C55.9988 53.5764 43.4628 66.1447 27.9988 66.1447C12.5348 66.1447 -0.00118249 53.5764 -0.00118247 38.0727C-0.00118244 22.569 -1.93055 -8.43262 13.5334 -8.43262C28.9974 -8.43262 55.9988 22.569 55.9988 38.0727Z",
    fill: "#FFAE09"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9276 36.6203C19.9502 36.6938 20.4524 36.5115 21.3111 36.5089C22.1543 36.5066 23.4227 36.7569 24.4665 37.6813L24.9557 38.1178L24.9158 37.4566C24.8671 36.5986 24.9771 35.643 25.2749 34.691C25.8932 32.6512 27.2018 31.1221 28.3042 30.2729C29.4031 29.3868 30.2643 29.1195 30.2228 29.0093C30.2129 28.9602 29.2821 29.093 28.0595 29.9346C26.8394 30.7362 25.3779 32.329 24.7123 34.5171C24.3939 35.5341 24.2942 36.5695 24.3684 37.4918L24.8207 37.2579C23.6004 36.2467 22.1914 36.069 21.2911 36.1707C20.366 36.2695 19.9023 36.5714 19.9245 36.6141L19.9276 36.6203Z",
    fill: "#CC8B07"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2305 4.45312C28.9434 5.93293 30.6699 8.64591 31.3649 12.6814",
    stroke: "#0064CC",
    strokeWidth: 1.47457,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7598 1C31.6558 3.21971 33.6289 7.16586 34.4741 10.7934",
    stroke: "#0064CC",
    strokeWidth: 1.47457,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49805 24.8125C6.73254 27.7267 8.41253 30.2631 11.6325 32.4172",
    stroke: "#0064CC",
    strokeWidth: 1.47457,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92578 24.8057C3.34428 29.0272 5.99505 32.2514 8.8046 34.3783",
    stroke: "#0064CC",
    strokeWidth: 1.47457,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1319_4347",
    x1: -88.023,
    y1: -40.6586,
    x2: 59.7544,
    y2: 105.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17418,
    stopColor: "#FFAE09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsAmount);
export default __webpack_public_path__ + "static/media/notifications-amount.8870de0f50a1d7c3fe4363953a0cf705.svg";
export { ForwardRef as ReactComponent };